import styled from "@emotion/styled";
import { Subtitle, Theme } from "@silvertours/front-shared";
import ArrowDown from "@engineering/icons/arrow-down";
import { formatColumnsAsStyles } from "../../../particle";
/* @TODO: Add correct FLOYT colors to theme. */ var ArrowDownIcon = /*#__PURE__*/ styled(ArrowDown, {
    target: "e1q69xgw0"
})("width:1.5rem;height:1.5rem;", Theme.mq("sm"), "{width:2rem;height:2rem;}");
var AccordionItemTitle = /*#__PURE__*/ styled(Subtitle, {
    target: "e1q69xgw1"
})("grid-column:span 10;transition:transform 0.15s cubic-bezier(0.4,0,0.2,1);");
var AccordionItemWrapper = /*#__PURE__*/ styled("details", {
    target: "e1q69xgw2"
})("border-top:", function(param) {
    var isFirst = param.isFirst;
    return isFirst ? "" : "1px solid #b6bfc1";
}, ";&[open] ", ArrowDownIcon, "{transform:scaleY(-1);}");
var AccordionItemPromptWrapper = /*#__PURE__*/ styled("summary", {
    target: "e1q69xgw3"
})("display:grid;grid-template-columns:repeat(12,minmax(0,1fr));align-items:center;padding-top:1rem;padding-bottom:1rem;cursor:pointer;&:hover{background-color:#f5f5f5;", AccordionItemTitle, "{transform:translateX(0.5rem);}}&::-webkit-details-marker{display:none;}", Theme.mq("lg"), "{padding-top:1.5rem;padding-bottom:1.5rem;}");
var AccordionItemContentWrapper = /*#__PURE__*/ styled("div", {
    target: "e1q69xgw4"
})("display:grid;grid-template-columns:repeat(12,minmax(0,1fr));gap:1.5rem;margin-bottom:1rem;", Theme.mq("lg"), "{margin-top:1rem;margin-bottom:1.5rem;}");
var AccordionItemArrow = /*#__PURE__*/ styled("span", {
    target: "e1q69xgw5"
})("grid-column:span 2;display:flex;justify-content:end;fill:", function(param) {
    var theme = param.theme;
    return theme.color.secondary100;
}, ";");
var AccordionFigure = /*#__PURE__*/ styled("figure", {
    target: "e1q69xgw6"
})(function(param) {
    var rules = param.rules;
    var ref;
    return (ref = rules.columns) === null || ref === void 0 ? void 0 : ref.map(formatColumnsAsStyles);
}, ";filter:drop-shadow(0 10px 25px rgb(0 0 0 / 8%));img{border-radius:0.75rem;}");
export { ArrowDownIcon, AccordionItemWrapper, AccordionItemPromptWrapper, AccordionItemContentWrapper, AccordionItemTitle, AccordionItemArrow, AccordionFigure };
